import type {
  Asset,
  ChargePoint,
  ChargingProfile,
  Connector,
  GridConnection,
  Profile,
  Transaction,
  User,
  Vehicle,
} from '@/types/swagger';

// Api calls
export enum RequestStatus {
  IDLE,
  SCHEDULED,
  FETCHING,
  SUCCESS,
  ERROR,
}

export interface WhitelabelConfig {
  api: string;
  playStoreLink?: string;
  appStoreLink?: string;
  azure?: {
    tenantID: string;
    clientID: string;
    redirectUri: string;
  };
}

export type PatchUserType = Partial<Omit<User, 'profile'> & { profile: Partial<Profile> }>;

export interface NormalizedTransactionResponse {
  entities: {
    transactionsByTimestamp: Record<string, Transaction>;
  };
}

export interface NormalizedVehicleResponse {
  entities: {
    vehicles: Record<number, Vehicle>;
  };
}

export interface NormalizedConnectorResponse {
  entities: {
    connectors: Record<number, Connector>;
    charging_profiles: Record<number, ChargingProfile>;
    transactions: Record<number, Transaction>;
    vehicles: Record<number, Vehicle>;
  };
}

export interface NormalizedAssetResponse {
  entities: {
    assets: Record<number, Asset>;
    grid_connections: Record<number, GridConnection>;
    charge_points: Record<number, ChargePoint>;
  };
}

export interface NormalizedChargePointResponse {
  entities: {
    connectors: Record<number, Connector>;
    charge_points: Record<number, ChargePoint>;
    charging_profiles: Record<number, ChargingProfile>;
    transactions: Record<number, Transaction>;
    vehicles: Record<number, Vehicle>;
  };
}

export interface NormalizedGridConnectionResponse {
  entities: {
    grid_connections: GridConnection[];
    charge_points: ChargePoint[];
    charging_profiles: ChargingProfile[];
    connectors: Connector[];
  };
}

export interface UnsavedSubscription {
  id?: number;
  in_app: boolean;
  email: boolean;
  action_code: string;
}
export interface WebsocketNotification {
  notification: number;
  name: string;
  charge_point_name?: string;
  asset_name?: string;
  timestamp: string;
  url: number;
  action_code: string;
  user_pk: string;
}

export enum SubscriptionType {
  WEB = 'web',
  MOBILE = 'mobile',
  EMAIL = 'email',
}

export interface LatLng {
  latitude: number;
  longitude: number;
}

export interface ReservationBounds {
  upper: string;
  lower: string;
  bounds: string;
}

export interface DataSet {
  data: number[];
  weight?: number;
  borderWidth?: number;
  backgroundColor: string[];
}

export interface DonutData {
  labels: string[];
  datasets: DataSet[];
}

export enum ConnectorsSortingStrategy {
  ALPHABETICAL = 'Alphabetical',
  CONNECTOR_ID_ASC = 'ConnectorId',
  CONNECTOR_ID_DESC = 'ConnectorIdDesc',
}

export interface FcWidget {
  init: (data: {
    token: string;
    host: string;
    open: boolean;
    firstName?: string;
    lastName?: string;
    email?: string;
    externalId?: string;
    restoreId?: string | null;
  }) => void;
  user: {
    setProperties: (data: {
      firstName?: string;
      lastName?: string;
      email: string;
      phone?: string;
      cf_client?: string;
      cf_app_version?: string;
    }) => void;
    create: (
      data: {
        firstName: string;
        lastName: string;
        email: string;
        phone?: string;
        cf_client?: string;
        cf_app_version?: string;
      },
      callback: (res: { status: number; restoreId: string }) => void
    ) => void;
  } | null;
}
